<template>
  <div class="user-login-container ds-page-container">
    <el-row :gutter="20" class="ds-layout-row">
      <el-col :xs="24" :sm="6" :lg="4" class="ds-sidebar">
        <el-card class="store-list-card ds-card">
          <div slot="header" class="ds-card-header">
            <i class="el-icon-office-building margin-right-sm"></i>
            <span>选择商户</span>
          </div>
          <div class="store-list">
            <ul class="store-ul">
              <li v-for="(item, index) in userLoginInfo.stores" :key="index" @click="swatchStore(item)"
                :class="{ 'selected-store': userLoginInfo.conditions.storeId == item.storeId }">
                <i class="el-icon-shopping-bag-2"></i>
                {{ item.name }}
                <span v-if="item.storeTypeName" class="ds-tag">{{ item.storeTypeName }}</span>
              </li>
            </ul>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="18" :lg="20" class="ds-main">
        <el-card class="search-card ds-card">
          <div slot="header" class="ds-card-header">
            <i class="el-icon-search margin-right-sm"></i>
            <span>{{ $t('userLogin.search.title') }}</span>
          </div>
          <el-row :gutter="20" class="ds-search-row">
            <el-col :xs="24" :sm="12" :md="6">
              <div class="ds-form-item">
                <label>{{ $t('userLogin.search.name') }}</label>
                <el-input :placeholder="$t('userLogin.search.name')" v-model="userLoginInfo.conditions.name" clearable class="ds-input" />
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <div class="ds-form-item">
                <label>{{ $t('userLogin.search.tel') }}</label>
                <el-input type="number" :placeholder="$t('userLogin.search.tel')" v-model="userLoginInfo.conditions.tel"
                  clearable class="ds-input" />
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <div class="ds-form-item">
                <label>{{ $t('userLogin.search.startTime') }}</label>
                <el-date-picker v-model="userLoginInfo.conditions.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="$t('userLogin.search.startTime')" class="ds-input">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <div class="ds-form-item">
                <label>{{ $t('userLogin.search.endTime') }}</label>
                <el-date-picker v-model="userLoginInfo.conditions.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="$t('userLogin.search.endTime')" class="ds-input">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :xs="24" class="ds-form-actions">
              <el-button type="primary" @click="_queryUserLoginMethod" class="ds-btn-primary">
                <i class="el-icon-search"></i> {{ $t('common.search') }}
              </el-button>
              <el-button @click="_resetSearch" class="ds-btn-default">
                <i class="el-icon-refresh"></i> 重置
              </el-button>
            </el-col>
          </el-row>
        </el-card>

        <el-card class="table-card ds-card">
          <div slot="header" class="ds-card-header">
            <i class="el-icon-document margin-right-sm"></i>
            <span>{{ $t('userLogin.table.title') }}</span>
            <span class="ds-record-count">共 {{ pagination.total }} 条记录</span>
          </div>
          <el-table v-loading="loading" :data="userLoginInfo.logs" border style="width: 100%" class="ds-table">
            <el-table-column prop="loginId" :label="$t('userLogin.table.loginId')" align="center" width="100" />
            <el-table-column prop="parentOrgName" :label="$t('userLogin.table.parentOrgName')" align="center" min-width="120">
              <template slot-scope="scope">
                <span class="ds-org-name">{{ scope.row.parentOrgName || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="orgName" :label="$t('userLogin.table.orgName')" align="center" min-width="120">
              <template slot-scope="scope">
                <span class="ds-org-name">{{ scope.row.orgName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="userName" :label="$t('userLogin.table.userName')" align="center" width="120">
              <template slot-scope="scope">
                <span class="ds-user-name">
                  <i class="el-icon-user"></i> {{ scope.row.userName }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="loginTime" :label="$t('userLogin.table.loginTime')" align="center" width="180">
              <template slot-scope="scope">
                <span class="ds-time">
                  <i class="el-icon-time"></i> {{ scope.row.loginTime }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="userId" :label="$t('userLogin.table.userId')" align="center" width="120">
              <template slot-scope="scope">
                <el-tag size="mini" type="info" class="ds-id-tag">{{ scope.row.userId }}</el-tag>
              </template>
            </el-table-column>
          </el-table>

          <div class="ds-pagination-wrapper">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.size"
              layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="ds-pagination">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryUserLogin, listStores } from '@/api/user/userLoginApi'

export default {
  name: 'UserLoginList',
  data() {
    return {
      loading: false,
      userLoginInfo: {
        logs: [],
        stores: [],
        conditions: {
          name: '',
          tel: '',
          storeId: '',
          startTime: '',
          endTime: '',
          page: 1,
          row: 10
        }
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.loadData()
    this._listListStores()
  },
  methods: {
    async loadData() {
      try {
        this.loading = true
        const params = {
          ...this.userLoginInfo.conditions,
          page: this.pagination.current,
          row: this.pagination.size
        }
        const { data, total } = await queryUserLogin(params)
        this.userLoginInfo.logs = data
        this.pagination.total = total
      } catch (error) {
        this.$message.error(this.$t('userLogin.fetchError'))
      } finally {
        this.loading = false
      }
    },
    async _listListStores() {
      try {
        const params = {
          page: 1,
          row: 100
        }
        const { data } = await listStores(params)
        this.userLoginInfo.stores = [
          { storeId: '', name: this.$t('userLogin.allStores') },
          ...data
        ]
      } catch (error) {
        this.$message.error(this.$t('userLogin.storeFetchError'))
      }
    },
    swatchStore(item) {
      this.userLoginInfo.conditions.storeId = item.storeId
      this.pagination.current = 1
      this.loadData()
    },
    _queryUserLoginMethod() {
      this.pagination.current = 1
      this.loadData()
    },
    _resetSearch() {
      this.userLoginInfo.conditions.name = ''
      this.userLoginInfo.conditions.tel = ''
      this.userLoginInfo.conditions.startTime = ''
      this.userLoginInfo.conditions.endTime = ''
      this.pagination.current = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.ds-page-container {
  padding: var(--ds-spacing-lg);
  background: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-layout-row {
  min-height: calc(100vh - 120px);
}

.ds-sidebar {
  .ds-card {
    height: fit-content;
    max-height: calc(100vh - 140px);
    position: sticky;
    top: var(--ds-spacing-lg);
  }
}

.ds-card {
  border-radius: var(--ds-radius-md);
  border: 1px solid var(--ds-gray-300);
  box-shadow: var(--ds-shadow-sm);
  transition: box-shadow var(--ds-transition-base);

  &:hover {
    box-shadow: var(--ds-shadow-md);
  }
}

.ds-card-header {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: var(--ds-primary);

  i {
    font-size: 18px;
  }
}

.ds-record-count {
  margin-left: auto;
  font-size: var(--ds-font-size-sm);
  color: var(--ds-gray-500);
  font-weight: 400;
}

.store-list-card {
  overflow-y: auto;

  .store-list {
    .store-ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        padding: 12px;
        cursor: pointer;
        border-radius: var(--ds-radius-sm);
        margin-bottom: 4px;
        text-align: left;
        display: flex;
        align-items: center;
        gap: 8px;
        transition: background-color var(--ds-transition-fast),
                    color var(--ds-transition-fast);

        i {
          color: var(--ds-gray-500);
          font-size: 14px;
        }

        &:hover {
          background-color: rgba(var(--ds-primary-rgb), 0.08);
          color: var(--ds-primary);
        }

        &.selected-store {
          background-color: var(--ds-primary);
          color: white;

          i {
            color: white;
          }

          .ds-tag {
            background-color: rgba(255, 255, 255, 0.2);
            color: white;
          }
        }
      }
    }
  }
}

.ds-tag {
  font-size: 10px;
  padding: 2px 6px;
  background-color: var(--ds-gray-200);
  border-radius: var(--ds-radius-full);
  margin-left: auto;
}

.search-card {
  margin-bottom: var(--ds-spacing-lg);
}

.ds-search-row {
  padding: var(--ds-spacing-sm) 0;
}

.ds-form-item {
  margin-bottom: var(--ds-spacing-sm);

  label {
    display: block;
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-600);
    margin-bottom: var(--ds-spacing-xs);
    font-weight: 500;
  }
}

.ds-input {
  width: 100%;
}

.ds-form-actions {
  display: flex;
  gap: var(--ds-spacing-sm);
  justify-content: flex-start;
  padding-top: var(--ds-spacing-sm);
}

.ds-btn-primary {
  background-color: var(--ds-primary) !important;
  border-color: var(--ds-primary) !important;
  font-weight: 500;

  &:hover {
    background-color: var(--ds-primary-light) !important;
    border-color: var(--ds-primary-light) !important;
  }
}

.ds-btn-default {
  background-color: white !important;
  border-color: var(--ds-gray-300) !important;
  color: var(--ds-gray-700);

  &:hover {
    border-color: var(--ds-primary) !important;
    color: var(--ds-primary) !important;
  }
}

.ds-table {
  border-radius: var(--ds-radius-md);
  overflow: hidden;

  .ds-org-name {
    color: var(--ds-gray-700);
  }

  .ds-user-name {
    color: var(--ds-primary);
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    i {
      font-size: 14px;
    }
  }

  .ds-time {
    color: var(--ds-gray-600);
    font-size: var(--ds-font-size-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    i {
      color: var(--ds-gray-400);
    }
  }

  .ds-id-tag {
    font-family: monospace;
    background-color: var(--ds-gray-100);
    border-color: var(--ds-gray-300);
    color: var(--ds-gray-600);
  }
}

.ds-pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: var(--ds-spacing-md) 0 0;
}

.ds-pagination {
  font-family: var(--ds-font-family);

  .el-pager li.active {
    background-color: var(--ds-primary) !important;
    color: white !important;
  }

  .el-pager li:hover {
    color: var(--ds-primary) !important;
  }
}

.user-login-container {
  padding: 20px;
}
</style>